import { render, staticRenderFns } from "./FeedDetail.vue?vue&type=template&id=4b09cb6e&scoped=true&"
import script from "./FeedDetail.vue?vue&type=script&lang=js&"
export * from "./FeedDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedDetail.vue?vue&type=style&index=0&id=4b09cb6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09cb6e",
  null
  
)

export default component.exports